// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Photo Studio Albums — light/dark via html.dark (filevault-theme) */

.studio-albums-scope {
  --sa-bg: #ffffff;
  --sa-surface: #ffffff;
  --sa-surface-muted: #f1f5f9;
  --sa-surface-elevated: #ffffff;
  --sa-border: rgba(15, 23, 42, 0.1);
  --sa-border-accent: rgba(31, 58, 52, 0.2);
  --sa-text: #0f172a;
  --sa-text-muted: #64748b;
  --sa-text-faint: #94a3b8;
  --sa-hero: linear-gradient(135deg, #ffffff 0%, #ffffff 35%, #eff6ff 100%);
  --sa-accent: #2563eb;
  --sa-accent-soft: rgba(31, 58, 52, 0.1);
  --sa-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  --sa-pulse: #f1f5f9;
  --sa-pulse-strong: #e4e1d9;
  color: var(--sa-text);
  transition: background-color 0.2s ease, color 0.2s ease;
}

html.dark .studio-albums-scope {
  --sa-bg: #151412;
  --sa-surface: #1c1a18;
  --sa-surface-muted: #1d4ed8;
  --sa-surface-elevated: #1c1a18;
  --sa-border: rgba(255, 255, 255, 0.1);
  --sa-border-accent: rgba(197, 192, 182, 0.25);
  --sa-text: #ffffff;
  --sa-text-muted: #a8a399;
  --sa-text-faint: #78746c;
  --sa-hero: linear-gradient(135deg, #1c1a18 0%, #151412 40%, #0f0e0c 100%);
  --sa-accent: #e2e8f0;
  --sa-accent-soft: rgba(197, 192, 182, 0.15);
  --sa-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
  --sa-pulse: #1d4ed8;
  --sa-pulse-strong: #332f2a;
}

.studio-albums-scope.studio-albums-page {
  background-color: var(--sa-bg);
  min-height: 100%;
}

.studio-albums-scope .studio-album-hero,
.studio-albums-scope .studio-album-toolbar {
  background: var(--sa-hero);
  border-color: var(--sa-border-accent);
  box-shadow: var(--sa-shadow);
}

.studio-albums-scope .bg-white {
  background-color: var(--sa-surface) !important;
}

.studio-albums-scope .bg-white\\/70,
.studio-albums-scope .bg-white\\/80,
.studio-albums-scope .bg-white\\/90 {
  background-color: color-mix(in srgb, var(--sa-surface) 85%, transparent) !important;
}

.studio-albums-scope .bg-gray-50 {
  background-color: var(--sa-surface-muted) !important;
}

.studio-albums-scope .bg-gray-100 {
  background-color: var(--sa-pulse-strong) !important;
}

.studio-albums-scope .border-gray-100,
.studio-albums-scope .border-gray-200 {
  border-color: var(--sa-border) !important;
}

.studio-albums-scope .border-\\[\\#D9E7FF\\] {
  border-color: var(--sa-border-accent) !important;
}

.studio-albums-scope .text-gray-900,
.studio-albums-scope .text-slate-900 {
  color: var(--sa-text) !important;
}

.studio-albums-scope .text-gray-800,
.studio-albums-scope .text-gray-700,
.studio-albums-scope .text-gray-600,
.studio-albums-scope .text-slate-700,
.studio-albums-scope .text-slate-600,
.studio-albums-scope .text-slate-500 {
  color: var(--sa-text-muted) !important;
}

.studio-albums-scope .text-gray-500,
.studio-albums-scope .text-gray-400,
.studio-albums-scope .text-gray-300,
.studio-albums-scope .text-slate-400 {
  color: var(--sa-text-faint) !important;
}

.studio-albums-scope .text-\\[\\#2563eb\\],
.studio-albums-scope .text-\\[\\#2731db\\] {
  color: var(--sa-accent) !important;
}

.studio-albums-scope .bg-\\[\\#2563eb\\]\\/10,
.studio-albums-scope .bg-\\[\\#2731db\\]\\/10 {
  background-color: var(--sa-accent-soft) !important;
}

.studio-albums-scope .bg-\\[\\#2731db\\],
.studio-albums-scope .bg-\\[\\#2563eb\\] {
  background-color: var(--sa-accent) !important;
  color: #ffffff !important;
}

.studio-albums-scope .border-\\[\\#2731db\\],
.studio-albums-scope .border-\\[\\#2563eb\\] {
  border-color: var(--sa-accent) !important;
}

.studio-albums-scope .ring-\\[\\#D9E7FF\\] {
  --tw-ring-color: var(--sa-border-accent) !important;
}

.studio-albums-scope input,
.studio-albums-scope select,
.studio-albums-scope textarea {
  background-color: var(--sa-surface) !important;
  color: var(--sa-text) !important;
}

.studio-albums-scope input::placeholder {
  color: var(--sa-text-faint) !important;
}

.studio-albums-scope select option {
  background-color: var(--sa-surface);
  color: var(--sa-text);
}

html.dark .studio-albums-scope .hover\\:bg-gray-50:hover,
html.dark .studio-albums-scope .hover\\:bg-slate-50:hover,
html.dark .studio-albums-scope .hover\\:bg-slate-100:hover {
  background-color: var(--sa-surface-muted) !important;
}

html.dark .studio-albums-scope .bg-gray-200,
html.dark .studio-albums-scope .animate-pulse.bg-gray-200 {
  background-color: var(--sa-pulse) !important;
}

html.dark .studio-albums-scope .bg-gray-100.animate-pulse,
html.dark .studio-albums-scope .from-gray-100,
html.dark .studio-albums-scope .via-gray-50,
html.dark .studio-albums-scope .to-gray-200 {
  --tw-gradient-from: var(--sa-pulse-strong) var(--tw-gradient-from-position) !important;
  --tw-gradient-to: var(--sa-pulse) var(--tw-gradient-to-position) !important;
}

html.dark .studio-albums-scope .bg-indigo-100 {
  background-color: var(--sa-accent-soft) !important;
}

html.dark .studio-albums-scope .bg-indigo-200\\/90 {
  background-color: color-mix(in srgb, var(--sa-accent) 35%, transparent) !important;
}

html.dark .studio-albums-scope .divide-slate-200 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--sa-border);
}

html.dark .studio-albums-scope .shadow-sm,
html.dark .studio-albums-scope .shadow-md,
html.dark .studio-albums-scope .shadow-xl {
  --tw-shadow-color: rgba(0, 0, 0, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/photoStudioAlbumTheme.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,yEAAyE;EACzE,oBAAoB;EACpB,uCAAuC;EACvC,8CAA8C;EAC9C,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,yEAAyE;EACzE,oBAAoB;EACpB,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;EAGE,mFAAmF;AACrF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;;;EAME,sCAAsC;AACxC;;AAEA;;;;EAIE,sCAAsC;AACxC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;EAGE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;;EAGE,oDAAoD;AACtD;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;;;EAIE,sFAAsF;EACtF,2EAA2E;AAC7E;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,sCAAsC;AACxC","sourcesContent":["/* Photo Studio Albums — light/dark via html.dark (filevault-theme) */\n\n.studio-albums-scope {\n  --sa-bg: #ffffff;\n  --sa-surface: #ffffff;\n  --sa-surface-muted: #f1f5f9;\n  --sa-surface-elevated: #ffffff;\n  --sa-border: rgba(15, 23, 42, 0.1);\n  --sa-border-accent: rgba(31, 58, 52, 0.2);\n  --sa-text: #0f172a;\n  --sa-text-muted: #64748b;\n  --sa-text-faint: #94a3b8;\n  --sa-hero: linear-gradient(135deg, #ffffff 0%, #ffffff 35%, #eff6ff 100%);\n  --sa-accent: #2563eb;\n  --sa-accent-soft: rgba(31, 58, 52, 0.1);\n  --sa-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);\n  --sa-pulse: #f1f5f9;\n  --sa-pulse-strong: #e4e1d9;\n  color: var(--sa-text);\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\nhtml.dark .studio-albums-scope {\n  --sa-bg: #151412;\n  --sa-surface: #1c1a18;\n  --sa-surface-muted: #1d4ed8;\n  --sa-surface-elevated: #1c1a18;\n  --sa-border: rgba(255, 255, 255, 0.1);\n  --sa-border-accent: rgba(197, 192, 182, 0.25);\n  --sa-text: #ffffff;\n  --sa-text-muted: #a8a399;\n  --sa-text-faint: #78746c;\n  --sa-hero: linear-gradient(135deg, #1c1a18 0%, #151412 40%, #0f0e0c 100%);\n  --sa-accent: #e2e8f0;\n  --sa-accent-soft: rgba(197, 192, 182, 0.15);\n  --sa-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);\n  --sa-pulse: #1d4ed8;\n  --sa-pulse-strong: #332f2a;\n}\n\n.studio-albums-scope.studio-albums-page {\n  background-color: var(--sa-bg);\n  min-height: 100%;\n}\n\n.studio-albums-scope .studio-album-hero,\n.studio-albums-scope .studio-album-toolbar {\n  background: var(--sa-hero);\n  border-color: var(--sa-border-accent);\n  box-shadow: var(--sa-shadow);\n}\n\n.studio-albums-scope .bg-white {\n  background-color: var(--sa-surface) !important;\n}\n\n.studio-albums-scope .bg-white\\/70,\n.studio-albums-scope .bg-white\\/80,\n.studio-albums-scope .bg-white\\/90 {\n  background-color: color-mix(in srgb, var(--sa-surface) 85%, transparent) !important;\n}\n\n.studio-albums-scope .bg-gray-50 {\n  background-color: var(--sa-surface-muted) !important;\n}\n\n.studio-albums-scope .bg-gray-100 {\n  background-color: var(--sa-pulse-strong) !important;\n}\n\n.studio-albums-scope .border-gray-100,\n.studio-albums-scope .border-gray-200 {\n  border-color: var(--sa-border) !important;\n}\n\n.studio-albums-scope .border-\\[\\#D9E7FF\\] {\n  border-color: var(--sa-border-accent) !important;\n}\n\n.studio-albums-scope .text-gray-900,\n.studio-albums-scope .text-slate-900 {\n  color: var(--sa-text) !important;\n}\n\n.studio-albums-scope .text-gray-800,\n.studio-albums-scope .text-gray-700,\n.studio-albums-scope .text-gray-600,\n.studio-albums-scope .text-slate-700,\n.studio-albums-scope .text-slate-600,\n.studio-albums-scope .text-slate-500 {\n  color: var(--sa-text-muted) !important;\n}\n\n.studio-albums-scope .text-gray-500,\n.studio-albums-scope .text-gray-400,\n.studio-albums-scope .text-gray-300,\n.studio-albums-scope .text-slate-400 {\n  color: var(--sa-text-faint) !important;\n}\n\n.studio-albums-scope .text-\\[\\#2563eb\\],\n.studio-albums-scope .text-\\[\\#2731db\\] {\n  color: var(--sa-accent) !important;\n}\n\n.studio-albums-scope .bg-\\[\\#2563eb\\]\\/10,\n.studio-albums-scope .bg-\\[\\#2731db\\]\\/10 {\n  background-color: var(--sa-accent-soft) !important;\n}\n\n.studio-albums-scope .bg-\\[\\#2731db\\],\n.studio-albums-scope .bg-\\[\\#2563eb\\] {\n  background-color: var(--sa-accent) !important;\n  color: #ffffff !important;\n}\n\n.studio-albums-scope .border-\\[\\#2731db\\],\n.studio-albums-scope .border-\\[\\#2563eb\\] {\n  border-color: var(--sa-accent) !important;\n}\n\n.studio-albums-scope .ring-\\[\\#D9E7FF\\] {\n  --tw-ring-color: var(--sa-border-accent) !important;\n}\n\n.studio-albums-scope input,\n.studio-albums-scope select,\n.studio-albums-scope textarea {\n  background-color: var(--sa-surface) !important;\n  color: var(--sa-text) !important;\n}\n\n.studio-albums-scope input::placeholder {\n  color: var(--sa-text-faint) !important;\n}\n\n.studio-albums-scope select option {\n  background-color: var(--sa-surface);\n  color: var(--sa-text);\n}\n\nhtml.dark .studio-albums-scope .hover\\:bg-gray-50:hover,\nhtml.dark .studio-albums-scope .hover\\:bg-slate-50:hover,\nhtml.dark .studio-albums-scope .hover\\:bg-slate-100:hover {\n  background-color: var(--sa-surface-muted) !important;\n}\n\nhtml.dark .studio-albums-scope .bg-gray-200,\nhtml.dark .studio-albums-scope .animate-pulse.bg-gray-200 {\n  background-color: var(--sa-pulse) !important;\n}\n\nhtml.dark .studio-albums-scope .bg-gray-100.animate-pulse,\nhtml.dark .studio-albums-scope .from-gray-100,\nhtml.dark .studio-albums-scope .via-gray-50,\nhtml.dark .studio-albums-scope .to-gray-200 {\n  --tw-gradient-from: var(--sa-pulse-strong) var(--tw-gradient-from-position) !important;\n  --tw-gradient-to: var(--sa-pulse) var(--tw-gradient-to-position) !important;\n}\n\nhtml.dark .studio-albums-scope .bg-indigo-100 {\n  background-color: var(--sa-accent-soft) !important;\n}\n\nhtml.dark .studio-albums-scope .bg-indigo-200\\/90 {\n  background-color: color-mix(in srgb, var(--sa-accent) 35%, transparent) !important;\n}\n\nhtml.dark .studio-albums-scope .divide-slate-200 > :not([hidden]) ~ :not([hidden]) {\n  border-color: var(--sa-border);\n}\n\nhtml.dark .studio-albums-scope .shadow-sm,\nhtml.dark .studio-albums-scope .shadow-md,\nhtml.dark .studio-albums-scope .shadow-xl {\n  --tw-shadow-color: rgba(0, 0, 0, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
